import config from '../../../config';
import Request from '../../Request';

export default function create(values, onSuccess, onFailure) {
  return Request.post(`${config.apiUrl}/store_pages`, { store_page: values }, onSuccess, onFailure);
}